import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import BaseFormContainer from '../../common/components/form/BaseFormContainer';
import CampaignForm from './CampaignForm';

import * as channelActions from '../../channel/channel.actions';
import * as campaignActions from '../campaign.actions';
import { getAllChannels } from '../../channel/channel.selectors';
import { Localize } from '../../../locale/localization';
import Dialog from '../../common/components/Dialog';

const constraints = {
  channel: {
    presence: {
      message: `^${Localize('form.edit.campaign.channel.error')}`,
    },
  },
  bonusPercentage: {
    presence: {
      message: `^${Localize('form.edit.campaign.bonus.error')}`,
    },
    numericality: {
      greaterThanOrEqualTo: 0,
      lessThanOrEqualTo: 100,
      notValid: `^${Localize('form.edit.campaign.bonus.error')}`,
      notGreaterThanOrEqualTo: `^${Localize('form.edit.campaign.bonus.error')}`,
      notLessThanOrEqualTo: `^${Localize('form.edit.campaign.bonus.error')}`,
    },
  },
  startDate: {
    presence: {
      message: `^${Localize('form.edit.campaign.startDate.error')}`,
    },
  },
  endDate: {
    presence: {
      message: `^${Localize('form.edit.campaign.endDate.error')}`,
    },
  },
};

class CampaignFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    let startDate = new Date();
    startDate.setHours(0, 0, 0, 0);

    let endDate = new Date();
    endDate.setHours(23, 59, 59, 999);

    const formData = {
      channel: '',
      startDate: moment(startDate),
      endDate: moment(endDate),
      bonusPercentage: 0,
      campaignExistsError: false,
    };

    this.state = {
      ...this.state,
      formData,
      isValid: true,
      dialogOpen: false,
    };
  }

  componentWillMount = () => {
    const { getChannels, getCampaign, id } = this.props;

    getChannels();
    if (id) {
      getCampaign(id).then(() => {
        const { campaign, channels } = this.props;
        const startDate = moment(campaign.startDate);
        const endDate = moment(campaign.endDate);
        const channel = campaign.channel ? campaign.channel._id : channels[0] ? channels[0]._id : this.props.channel;
        const bonusPercentage = campaign.bonusPercentage;

        const { formData } = this.state;

        this.setState({
          formData: {
            ...formData,
            channel,
            startDate,
            endDate,
            bonusPercentage,
          },
        });
      });
    }
  };

  getConstraints = () => constraints;

  doSubmit = formData => {
    const { updateCampaign, createCampaign, cancelPath, history } = this.props;
    if (this.props.id) {
      updateCampaign({
        _id: this.props.id,
        ...formData,
      }).then(() => {
        history.replace(cancelPath);
      });
    } else {
      createCampaign(formData).then(args => {
        // 409 create campaign check
        if (args && args.error && args.error.status) {
          this.campaignExistsError(true, this.validate);
        } else {
          history.replace(cancelPath);
        }
      });
    }
  };

  onCancel = event => {
    event.preventDefault();

    const { cancelPath, history } = this.props;
    history.replace(cancelPath);
  };

  onDelete = event => {
    event.preventDefault();
    this.setState({
      dialogOpen: true,
    });
  };

  cancelDelete = event => {
    this.setState({
      dialogOpen: false,
    });
  };

  confirmDelete = event => {
    const { deleteCampaign } = this.props;
    deleteCampaign(this.props.id).then(() => {
      this.setState({
        dialogOpen: false,
      });
      const { cancelPath, history } = this.props;
      history.replace(cancelPath);
    });
  };

  //NOTE: error handling special: campaignExistsError needs to be shown 1 time, and auto cleared by all inputs
  onInputChangeCheck = event => {
    if (this.state.formData.campaignExistsError) {
      this.removeCampaignExistsError(event);
    } else {
      this.onInputChange(event);
    }
  };

  onBlurCheck = event => {
    if (this.state.formData.campaignExistsError) {
      this.removeCampaignExistsError(event);
    } else {
      this.onBlur(event);
    }
  };

  campaignExistsError = () => {
    const { formData } = this.state;
    this.setState(
      {
        formData: {
          ...formData,
          campaignExistsError: true,
        },
      },
      this.validate
    );
  };

  removeCampaignExistsError = event => {
    const { formData } = this.state;
    this.setState(
      {
        formData: {
          ...formData,
          campaignExistsError: false,
        },
        isSubmitting: false,
      },
      this.onInputChange(event)
    );
  };

  render() {
    const { channels, id } = this.props;

    return (
      <div>
        <CampaignForm
          enabled={!this.state.isSubmitting}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
          onDelete={this.onDelete}
          onInputChange={this.onInputChangeCheck}
          onBlur={this.onBlurCheck}
          errors={this.state.errors}
          touchedFields={this.state.touchedFields}
          isValid={this.state.isValid}
          channels={channels}
          channel={this.state.formData.channel}
          startDate={this.state.formData.startDate}
          endDate={this.state.formData.endDate}
          bonusPercentage={this.state.formData.bonusPercentage}
          showDeleteButton={!!id}
        />

        <Dialog
          open={this.state.dialogOpen}
          title={Localize('campaign.delete.confirm')}
          cancelLabel={Localize('action.cancel')}
          confirmLabel={Localize('action.delete')}
          onCancel={this.cancelDelete}
          onConfirm={this.confirmDelete}
        >
          <p>{Localize('form.no.cancel')}</p>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state, { match, cancelPath }) => {
  const { id } = match.params;
  const channels = getAllChannels(state);
  const campaign = state.entities.campaign.byId[id];

  return {
    id,
    cancelPath,
    channels,
    campaign,
  };
};

const ConnectedCampaignFormContainer = connect(
  mapStateToProps,
  Object.assign({}, campaignActions, channelActions)
)(CampaignFormContainer);

export default withRouter(ConnectedCampaignFormContainer);



// WEBPACK FOOTER //
// ./src/modules/campaign/components/CampaignFormContainer.js